<h3 class="ui primary header">
  Close eWallet Account
  <i class="link times icon" (click)="closeModal()"></i>
</h3>

<esl-message-toast [(message)]="error"></esl-message-toast>
<esl-message-toast
  [(message)]="success"
  [messageType]="'success'"
></esl-message-toast>

<div class="info">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
      stroke="#202223"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <p>
    To deactivate your eWallet account, your balance must be zero. Please ensure
    all funds are fully used before proceeding with deactivation.
  </p>
</div>

<div class="content">
  <div class="ui basic vertical segment">
    <div
      class="account"
      [ngClass]="{ non_zero: modal.context.account.balance > 0 }"
    >
      <h3>{{ modal.context.account.currencyShortName }}</h3>
      <h4>
        Balance: {{ modal.context.account.currencyCode
        }}{{ formatAmount(modal.context.account.balance || 0) }}
      </h4>
      <h4>
        Book Balance: {{ modal.context.account.currencyCode
        }}{{ formatAmount(modal.context.account.bookBalance || 0) }}
      </h4>
    </div>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui basic primary button" (click)="closeModal()">
      Back
    </button>
    <button
      *ngIf="
        !modal.context.account.balance || modal.context.account.balance == 0
      "
      [disabled]="
        modal.context.account.balance > 0
      "
      (click)="deactivateAccount()"
      class="ui primary button"
      [ngClass]="{ loading: pending }"
      autofocus
    >
      Close account
    </button>
    <!-- <button
      *ngIf="modal.context.account.balance > 0"
      class="ui primary button"
      (click)="modal.approve(true)"
      autofocus
    >
      Withdraw all funds
    </button> -->
  </div>
</div>
